<div class="action-button-container">
	<button type="button" mat-button color="accent" class="cancel-button service-button"
		(click)="goBack()"><span class="text-color" translate>dashboard.cancel </span>
	</button>
	<button type="button" mat-button color="accent" class="service-button" (click)="onSave()"><span
			class="text-color" translate>settings.save-changes </span>
		<mat-icon iconPositionEnd class="icon-color" svgIcon="save_disk"></mat-icon>
	</button>
</div>
<div class="card-block">
	<div class="card-title" translate>settings.services-mangement</div>
	<div class="drag-drop-container" *ngIf="!isLoading else loading">
		<div class="column-content right-separator">
			<div class="container-title" translate>manage.services.drag-and-drop-items-on-the-right</div>
			<div cdkDropList #pinnedList="cdkDropList" [cdkDropListData]="addedServices"
				[cdkDropListConnectedTo]="[hidedList]" class="user-drag-list"
				(cdkDropListDropped)="drop($event)">
				<div class="drag-service" *ngFor="let item of addedServices" cdkDrag>
					<mat-icon class="drag-icon" svgIcon="md:drag_indicator">
					</mat-icon>
					<div class="inline-items">
						<span class="drag-box-added-label">{{item.name}}</span>
						<div class="drag-box-added-label">{{item.description}}</div>
					</div>
				</div>
			</div>
			<div class="services-placeholder" *ngIf="addedServices && addedServices.length === 0">
				<mat-icon svgIcon="md:filter_arrow_up"></mat-icon>
				<p translate>settings.drag-drop-services-here</p>
			</div>
		</div>
		<div class="add-service-margin column-content">
			<div class="add-services container-title">
				<mat-icon color="accent" svgIcon="add"></mat-icon>
				<span translate>manage.services.add-services</span>
			</div>
			<div class="search-toggle-container">
				<mat-form-field class="column-search" appearance="outline" subscriptSizing="dynamic">
					<mat-icon svgIcon="search" class="column-search-icon" matPrefix></mat-icon>
					<input [placeholder]="'search.placeholder' | translate" matInput type="text"
						spellcheck="false" autocomplete="off" [formControl]="searchTextControl" />
					<button type="button" *ngIf="searchTextControl.value" matSuffix mat-icon-button
						(click)="searchTextControl.reset('');" tabindex="-1">
						<mat-icon svgIcon="md:close"></mat-icon>
					</button>
				</mat-form-field>
				<div class="drag-container-header">
					<copo-slide-button labelBefore="settings.add-all-services"
						(toggleChange)="onToggleChange()" [checked]="togglePosition">
					</copo-slide-button>
				</div>
			</div>
			<div cdkDropList #hidedList="cdkDropList" [cdkDropListData]="allServices"
				[cdkDropListConnectedTo]="[pinnedList]" class="overflow"
				(cdkDropListDropped)="drop($event)">
				<div class="drag-service" *ngFor="let item of allServices" cdkDrag>
					<mat-icon class="drag-icon" svgIcon="md:drag_indicator">
					</mat-icon>
					<div class="inline-items">
						<span class="drag-box-added-label">{{item.name}}</span>
						<div class="drag-box-added-label">{{item.description}}</div>
					</div>
				</div>
				<div class="hide-placeholder" *ngIf="allServices && allServices.length === 0">
					<mat-icon svgIcon="md:filter_arrow_up"></mat-icon>
					<p translate>settings.all-services-added</p>
					<p translate>settings.drag-services-here</p>
				</div>
			</div>
		</div>
	</div>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>
